import React from "react";

const krushna_bankar = () => {
  return (
    <div>
      <h1>Krushna Bankar</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Students of CS branch and having CGPA more than 7 were allowed for
        aptitude test.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        Result of the aptitude round was announced at 10PM on the same day of
        the aptitude round, interviews were scheduled the next day.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        The aptitude round consisted of two coding questions and 10
        multiple-choice questions from DBMS, OS, CN, and OOP. One of the coding
        questions was straightforward and everyone was able to solve it, while
        the other was of medium difficulty level. Students who managed to pass
        at least some test cases of the second question were shortlisted. More
        weightage was given to the coding section.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        21 students were shortlisted after the Aptitude Round.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The results were announced at 10 PM the day before the interview, so I
        didn’t get much time to prepare. I revised my project and went through
        some DSA questions.
        <br />
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
      </p>

      <p>
        <strong>1. Technical Round:</strong>
        <br />
        In the beginning, I was asked to give my introduction, followed by some
        simple DSA questions, which I answered in detail. Then, she asked me
        about the project mentioned on my resume and some OOP-related
        questions.16 students were shortlisted after this round.
      </p>

      <p>
        <strong>2. Professional Fitness Round:</strong>
        <br />
        In this round, she asked me about everything I had mentioned on my
        resume. She questioned me in depth about my project and then presented a
        real problem faced by their firm, asking how I would handle it. I
        explained my approach to solving the problem. 9 Students were
        shortlisted after this round.
      </p>

      <p>
        <strong>3. HR Round:</strong>
        <br />
        This was a chill round. He asked me to give a brief introduction,
        followed by questions about my biggest failures and achievements, my
        strengths and weaknesses, and why I wanted to join DB. 7 students were
        given final offer.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        Focus on solving DSA questions and make sure the interviewer can
        understand your thought process. Also, have an in-depth understanding of
        your project
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Strivers SDE sheet for DSA, Geeks for Geeks, Leetcode.
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        Not many questions were asked about clubs and extracurricular
        activities, but I mentioned them during the HR round - it can definitely
        help you there.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        Stay consistent and you will get rewarded for your hard work. Start
        early. Be mentally prepared because the internship season starts right
        after your third year begins. Be clear about what you want to include in
        your resume, don't add anything you don’t actually know, since most
        interviews start with your resume as the base for discussion. Work on
        your communication skills and try to keep the interview more like a
        conversation rather than a strict Q\&amp;A or viva session. Also, think
        before you speak, especially during the HR round. It really helps if
        you’ve prepared answers to common HR questions in advance.
      </p>

      <p>
        <strong>Contact Info </strong>
        <br />
        <strong>Phone No :</strong> 7498992277
        <br />
        <strong>Email :</strong> <a href="mailto:bankarkl23.comp@coeptech.ac.in">bankarkl23.comp@coeptech.ac.in</a>
      </p>
    </div>
  );
};

export default krushna_bankar;
